import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Faq as FaqInterface } from '@redirector-service/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FAQService {

  private static API_HOST = environment.apiHost || '';

  constructor(
    private http: HttpClient,
  ) { }

  getFAQs(): Observable<FaqInterface[]> {
    return this.http.get<FaqInterface[]>(`${FAQService.API_HOST}/api/faq`);
  }
}
